import { useMemo } from 'react';
import { ProductItem, Title } from '@recargas-dominicanas/core/components';
import { useProducts } from '@recargas-dominicanas/core/store';
import type { IProduct } from '@recargas-dominicanas/core/types';
import { style } from './products.module.css';

interface Props {
  search: string;
  onClick: (product: IProduct) => void;
  onClearSearch: () => void;
}

export function Products(props: Props) {

  const { search, onClick, onClearSearch } = props;

  const productsData = useProducts().get();
  
  const products = useMemo(() => 
    productsData.filter(product => 
      product.name
        .toLowerCase()
        .includes(search.trim().toLowerCase())
    )
  , [productsData, search]);
  
  const topups = products.filter(product => product.type === 'Recarga');
  const dataPlans = products.filter(product => product.type === 'Paquetico');
  const pins = products.filter(product => product.type === 'Pin');
  const invoices = products.filter(product => product.type === 'Factura' || product.type === 'Seguro');

  function handleProductClick(product: IProduct) {
    onClick(product);
    onClearSearch();
  }

  return (
    <div className={style.container}>
      {topups.length !== 0 &&
        <div className={style.content}>
          <Title style={style.title} title='Recargas'/>
          <div className={style.products}>
            {
              topups.map(product => (
                <ProductItem
                  style={style.productItem}
                  key={product.id}
                  product={product}
                  onClick={() => handleProductClick(product)}/>
              ))
            }
          </div>
        </div>
      }
      {dataPlans.length !== 0 &&
        <div className={style.content}>
          <Title style={style.title} title='Paqueticos'/>
          <div className={style.products}>
            {
              dataPlans.map(product => (
                <ProductItem
                  style={style.productItem}
                  key={product.id}
                  product={product}
                  onClick={() => handleProductClick(product)} />
              ))
            }
          </div>
        </div>
      }
      {invoices.length !== 0 &&
        <div className={style.content}>
          <Title style={style.title} title='Servicios'/>
          <div className={style.products}>
            {
              invoices.map(product => (
                <ProductItem
                  style={style.productItem}
                  key={product.id}
                  product={product}
                  onClick={() => handleProductClick(product)} />
              ))
            }
          </div>
        </div>
      }
      {pins.length !== 0 &&
        <div className={style.content}>
          <Title style={style.title} title='Pines'/>
          <div className={style.products}>
            {
              pins.map(product => (
                <ProductItem
                  style={style.productItem}
                  key={product.id}
                  product={product}
                  onClick={() => handleProductClick(product)} />
              ))
            }
          </div>
        </div>
      }
    </div>
  );
}
